import { IconProps } from './icon';

export function IconArrowRight({
  size = '100%',
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 31 31"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3335 16.0729C22.3166 16.056 22.3167 16.0285 22.3336 16.0116C22.3506 15.9946 22.3507 15.9669 22.3337 15.9499L18.6612 12.2774C18.6442 12.2604 18.6166 12.2604 18.5996 12.2774C18.5826 12.2944 18.555 12.2944 18.538 12.2774L15.1596 8.89899C15.014 8.75337 14.7779 8.75337 14.6323 8.89899L11.4255 12.1057C11.2799 12.2514 11.2799 12.4875 11.4255 12.6331L14.571 15.7786C14.7167 15.9242 14.7167 16.1603 14.571 16.3059L11.4259 19.4511C11.2803 19.5967 11.2803 19.8328 11.4259 19.9784L14.6326 23.1852C14.7782 23.3308 15.0143 23.3308 15.16 23.1852L18.5382 19.807C18.5551 19.7901 18.5825 19.7901 18.5994 19.807C18.6163 19.8239 18.6437 19.8239 18.6606 19.807L22.3335 16.1341C22.3504 16.1172 22.3504 16.0898 22.3335 16.0729Z"
        fill={fill}
      />
    </svg>
  );
}
